import { CompanyDemand, BattalionDeman } from "../Components/index.js";

export default [
    {
        path: "/ration/fresh/company-demand",
        component: CompanyDemand,
        name: "ration-fresh-company-demand",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/ration/fresh/battalion-demand",
        component: BattalionDeman,
        name: "ration-fresh-battalion-demand",
        meta: {
            requiresAuth: true,
        },
    },
];
